<template>
  <div>
    <babyTab :active.sync="activeTab" :tabs="tabs"></babyTab>
    <chooseNormal
      v-show="activeTab === 1"
      :symptom_list="symptom_list"
    ></chooseNormal>
    <chooseSelf
      v-show="activeTab === 0"
      :self-res.sync="selfRes"
      :commodity="commodity"
    ></chooseSelf>
  </div>
</template>
<script>
import babyTab from '@/components/common/babyTab/babyTab';
import chooseNormal from './chooseNormal';
import chooseSelf from './chooseSelf';

export default {
  components: {
    babyTab,
    chooseNormal,
    chooseSelf
  },
  props: {
    commodity: [Array],
    symptom_list: [Array]
  },
  data() {
    return {
      activeTab: 0,
      tabs: [{ label: '自选方案', value: 1 }],
      selfRes: ''
    };
  }
};
</script>
